import { Tab } from 'bootstrap';

export default function initTabs() {

  function showTabFromHash(hash) {
    const tabToShow = document.querySelector(`button[data-bs-target="${hash}"]`);
    if (tabToShow) {
      new Tab(tabToShow).show();
    }
  }

  // Check if the URL has a hash and try to show the corresponding tab.
  if (window.location.hash) {
    showTabFromHash(window.location.hash);
  }

  // Update hash in URL when a tab is clicked.
  const tabButtons = document.querySelectorAll('.page-header-tabs button[data-bs-toggle="tab"]');
  tabButtons.forEach(tab => {
    tab.addEventListener('click', function (e) {
      history.pushState(null, null, e.target.getAttribute('data-bs-target'));
    });
  });

  // Listen to hashchange events to handle the back/forward button.
  window.addEventListener('hashchange', function() {
    showTabFromHash(window.location.hash);
  });

  // Listen for the Bootstrap 'shown' event and update the URL hash.
  tabButtons.forEach(tab => {
    tab.addEventListener('shown.bs.tab', function (e) {
      const hash = e.target.getAttribute('data-bs-target');
      if (hash) {
        history.replaceState(null, null, hash);
      } else {
        history.replaceState(null, null, ' ');
      }
    });
  });
}
